import { isEditorX } from '../../utils/editorx';
export const defaultSettings = {
  apiUrl: isEditorX ? 'https://pix.editorx.com' : 'https://pix.wix.com',
  apiPath: '/services/google_photos',
  foldersLimit: 50,
  itemsLimit: 100
};